import { Sku } from '@/types';

import SkuElement from './SkuElement';

interface SkuSelectProps {
  onSkuChange: (event: any) => void;
  skus: Sku[];
  selectedSku: Sku;
}

export default function SkuSelect({ onSkuChange, skus, selectedSku }: SkuSelectProps) {
  const handleSkuChange = (event: any) => {
    const selectedSku = skus.find((sku) => sku.skuID === event.target.value);
    if (!selectedSku) return;
    onSkuChange(selectedSku);
  };

  return (
    <div className="flex flex-row py-5">
      {skus.map((sku) => (
        <SkuElement
          key={sku.skuID}
          sku={sku}
          selectedSku={selectedSku}
          handleSkuChange={handleSkuChange}
        />
      ))}
    </div>
  );
}
